import { request } from '@/utils/request'

export const ProviderJobService = {
    ignore(id) {
        return request.delete(`/api/manage/provider-jobs/${id}`)
    },
}
